import { render, staticRenderFns } from "./AxSelectBox.vue?vue&type=template&id=700099aa&scoped=true"
import script from "./AxSelectBox.vue?vue&type=script&lang=ts"
export * from "./AxSelectBox.vue?vue&type=script&lang=ts"
import style0 from "./AxSelectBox.vue?vue&type=style&index=0&id=700099aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700099aa",
  null
  
)

export default component.exports